// extracted by mini-css-extract-plugin
export var divider = "_pj-0";
export var systemMessage = "_pj-1";